import React from "react";
import { CardSummary } from "./CardSummary";
import { CashierSalesSummary } from "./CashierSalesSummary";
import { Denomination } from "./Denomination";
import { DepartmentSummary } from "./DipartmentSummary";
import { DiscountSummary } from "./DiscountSummary";
import { ForeignCurrency } from "./ForeignCurrency";
import { IssuedReturnedVoucher } from "./IssuedReturnVoucher";
import { ReturnSummary } from "./ReturnSummary";
import { SalesSummary } from "./SalesSummary";
import { OrderSummary } from "./OrderSummary";
import { CashReceived } from "./CashReceived";
import { VoucherSummary } from "./VoucherSummary";

export const EodReportTables = (eodData: any, source: string) => {
  const tableDetails = [
    {
      tableName: "Sales Summary",
      table: (
        <SalesSummary
          salesData={eodData.eodReportDetails.sales_summary}
          source={source}
        />
      ),
    },
    {
      tableName: "Order Summary",
      table: (
        <OrderSummary
          orderData={eodData.eodReportDetails.order_summary}
          source={source}
        />
      ),
    },
    {
      tableName: "Cash Received",
      table: (
        <CashReceived salesData={eodData.eodReportDetails} source={source} />
      ),
    },
    {
      tableName: "Card Summary",
      table: (
        <CardSummary
          cardData={eodData.eodReportDetails.credit_card_data}
          creditCardTotal={eodData.eodReportDetails.credit_card_total}
          source={source}
        />
      ),
    },
    {
      tableName: "Discount Summary",
      table: (
        <DiscountSummary
          discountDetails={eodData.eodReportDetails}
          source={source}
        />
      ),
    },
    {
      tableName: "Voucher Summary",
      table:
        eodData.eodReportDetails.voucherData &&
        eodData.eodReportDetails.voucherData.length ? (
          <VoucherSummary
            voucherData={
              eodData.eodReportDetails.voucherData
                ? eodData.eodReportDetails.voucherData
                : null
            }
            voucherTotalAmount={
              eodData.eodReportDetails?.voucher_total_amount ?? 0
            }
            source={source}
          />
        ) : null,
    },
    {
      tableName: "Issued Return Voucher",
      table: (
        <IssuedReturnedVoucher
          issuedVoucherCount={
            eodData.eodReportDetails.issued_voucher_data_count
          }
          issuedVoucherTotalAmount={
            eodData.eodReportDetails.issued_voucher_data_amount
          }
          source={source}
        />
      ),
    },

    {
      tableName: "Foreign Currency",
      table:
        eodData.eodReportDetails.foreign_currency_data &&
        eodData.eodReportDetails.foreign_currency_data.length ? (
          <ForeignCurrency
            foreignCurrencyData={eodData.eodReportDetails.foreign_currency_data}
            foreignCurrencyTotal={
              eodData.eodReportDetails.total_sum_foreign_currency
            }
            localForeignCurrencyTotal={
              eodData.eodReportDetails.local_foreign_currency_total
            }
            source={source}
          />
        ) : null,
    },
    {
      tableName: "Department Summary",
      table: (
        <DepartmentSummary
          departmentData={eodData.eodReportDetails.department_data}
          departmentTotal={eodData.eodReportDetails.department_total_amount}
          source={source}
        />
      ),
    },
    {
      tableName: "Cashier Sales Summary",
      table: (
        <CashierSalesSummary
          cashierData={eodData.eodReportDetails.cashier_data}
          cashierTotal={eodData.eodReportDetails.cashiers_total_system_amount}
          source={source}
        />
      ),
    },
    {
      tableName: "Return Summary",
      table: (
        <ReturnSummary voidReturn={eodData.eodReportDetails} source={source} />
      ),
    },
    {
      tableName: "Denomination",
      table: (
        <Denomination
          denominationData={eodData.eodReportDetails.denomination_data}
          denominationTotal={eodData.eodReportDetails.denomination_total_amount}
          source={source}
        />
      ),
    },
  ];

  return tableDetails;
};
